import Joi from 'joi';

export const boxSchema = Joi.object().keys({
  boxCopyCount: Joi.number().required(),
});
